var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{staticClass:"border-z-index",class:_vm.notification.show ? 'notification-position' : 'default-position',attrs:{"color":"primary","height":"6","fixed":"","flat":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }